@import '../../../theme.scss';

verdocs-template-star {
  display: flex;
  flex: 0 0 60px;
  align-items: center;
  flex-direction: row;
  font-family: $primary-font;

  .star {
    line-height: 10px;

    &.updating {
      animation: spinningStar 2s infinite linear;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }

  .count {
    color: #595c5d;
    font-size: 14px;
    margin-left: 10px;
  }
}

@keyframes spinningStar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
